import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './LocationsListDialogFooter.module.scss'

interface ILocationsListDialogFooterProps {
  onClose: () => void
}

export const LocationsListDialogFooter = ({ onClose }: ILocationsListDialogFooterProps) => {
  return (
    <div className={styles.actionsContainer}>
      <Button onClick={onClose}>
        <Translation text={TRANSLATION_KEYS.closeButton} />
      </Button>
    </div>
  )
}
